module.exports = __webpack_public_path__ + "static/media/Server.8ef84f48.png";